import { HttpStatusCode } from "@/services/api"
import axios from "axios"

export const utils = {
	// there is also the utilsMixin, which allows the usage of these methods as a mixin
	methods: {
		copyToClipboard (element: HTMLElement, text: string) {
			// https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript

			if (!text) return

			var textArea = document.createElement("textarea")
			textArea.value = text
			textArea.style.top = "0"
			textArea.style.left = "0"
			textArea.style.position = "fixed"

			element.appendChild(textArea)
			textArea.focus()
			textArea.select()

			document.execCommand("copy")

			element.removeChild(textArea)
		},
		pluralize (str: string) {
			if (str.toLowerCase().endsWith("s")) {
				return str
			} else {
				return `${str}s`
			}
		},
		sanitizeForCss (text: string) : string {
			return text.replace(/[^a-zA-Z0-9]/g, "")
		},
		/**
		 * @summary Checks that the browser is online
		 */
		async isOnline () {
			// onLine false always means offline
			if (!self.navigator.onLine) return false

			// Check we're online by sending a request to our own origin
			const url = new URL(self.location.origin)

			// Unique value to prevent cached responses
			url.searchParams.set("date", Date.now().toString())

			try {
				const response = await axios.get(url.toString())
				return response.status === HttpStatusCode.OK
			} catch {
				return false
			}
		}
	}
}
